import { useEffect } from "react";

/** Printable height of a Letter page at the 0.4in @page margin, with a little slack. */
const PAGE_INCHES = 9.9;

let measuring = false;

/**
 * Measures every `.print-area` sheet at the real printable width and scales it
 * down just enough to land on exactly one page. Sheets that already fit print
 * at full size.
 */
export function fitPrintSheets() {
  if (measuring) return;
  measuring = true;
  document.querySelectorAll(".print-area").forEach((sheet) => {
    sheet.style.setProperty("--print-zoom", "1");
    sheet.classList.add("print-measuring");
    const inches = sheet.scrollHeight / 96;
    sheet.classList.remove("print-measuring");
    const zoom = inches > PAGE_INCHES ? PAGE_INCHES / inches : 1;
    sheet.style.setProperty("--print-zoom", zoom.toFixed(3));
  });
  measuring = false;
}

/** Keeps the print scale in sync while the sheet is still filling in. */
export function usePrintFit(dep) {
  useEffect(() => {
    fitPrintSheets();
    const observer = new ResizeObserver(() => fitPrintSheets());
    document.querySelectorAll(".print-area").forEach((sheet) => observer.observe(sheet));
    window.addEventListener("beforeprint", fitPrintSheets);
    return () => {
      observer.disconnect();
      window.removeEventListener("beforeprint", fitPrintSheets);
    };
  }, [dep]);
}
